export default "__VITE_ASSET__DoB08rRN__"